import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=2abacdf0&scoped=true"
import script from "./VSwitch.vue?vue&type=script&lang=js"
export * from "./VSwitch.vue?vue&type=script&lang=js"
import style0 from "./VSwitch.vue?vue&type=style&index=0&id=2abacdf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abacdf0",
  null
  
)

export default component.exports